// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spin_loader__9i98u","spin":"Spin_spin__SvKoV"};